angular.element(function() {
	angular.bootstrap(document, ['iconoglobe']);
});
angular.module('iconoglobe')
.run(["$rootScope", "$http", "MetaUtilService","localStorageService", "UserLocation","LocaleService", "$transitions", "$location", "deviceBrowser", "$timeout", function($rootScope, $http, MetaUtilService, localStorageService, UserLocation, LocaleService, $transitions, $location, deviceBrowser, $timeout) {    
    var siteBaseUrl = window.location.host;
    if(siteBaseUrl.indexOf("iconoglobe.cn") > -1){
        LocaleService.setLocaleByDisplayName('中文');
		}
		var microSoft = deviceBrowser.isMS();
    $transitions.onStart({}, function(trans){
			
			var currStateName = trans.to().name;
			$rootScope.stateLoader = false;
			angular.element('.tooltip').remove();
			
			$rootScope.stateLoader = true;
      if(currStateName != "maps.world"){ 
        angular.element('#body').removeClass('mapbox-map'); 
        $rootScope.mapboxMap = ''; 
      } 
			
			$http.get('/api/isloggedin')
			.then(function(res) {
			//	console.log("moduleloginres",res);
				$rootScope.user = res.data;
				if (res.data.user != 1) {
					if (res.data.status == 1) {
							localStorageService.set('name', res.data.name);
							localStorageService.set('usercategory', res.data.usercategory);
							$rootScope.usercategory = res.data.usercategory;
							$rootScope.loggedusername = res.data.name;
							if (currStateName.indexOf('user') > -1 && (res.data.user == '3' || res.data.user == '2')){
								$location.path("/dataentry/list");
								return;
							}
							if (currStateName == 'base.login' || currStateName == 'base.signup') {
									$location.path("/");
							}
							if (currStateName == 'user.promotions') {
                                                            UserLocation.getUserOwnCountryData().then(function (data) {
                      //  console.log("promotion-init", "response -> UserLocation.getUserOwnCountryData()", data);
							    });
							}

					} else {
							localStorageService.remove('name');
						        localStorageService.remove('userowncountrydata');
							$rootScope.loggedusername = null;
							if(currStateName.indexOf('user') >= 0){
								$location.path("/");
							}
					}
				} else {
						localStorageService.remove('name');
						localStorageService.remove('userowncountrydata');
				}
				
			}, function(err){
				console.log(err);
			});  
    });
		$transitions.onSuccess({}, function(trans){
			$('body,html').scrollTop(0);
			var currStateName = trans.to().name;
			$rootScope.stateLoader = false;
			angular.element('.tooltip').remove();
			
			if( currStateName.split(".")[0] != "maps" &&	(angular.element('.page-loader').is(':visible') || 
			angular.element('.page-loading').is(':visible')) )
			{
					$(document).ready(function(){
						angular.element('.page-loader').hide();
						angular.element(".page-loading").hide(); 
					})
			}
			if(currStateName != "maps.world"){
				$rootScope.mapboxMap = '';
			}
			
			$rootScope.page = currStateName.split(".")[0];
			$rootScope.isTab = (window.innerWidth >= 768 && window.innerWidth <= 1024);
			if(currStateName == "maps.world" || currStateName.indexOf('user') >= 0){
				MetaUtilService.metaInformation({
    pageTitle: "iconoglobe - Discover the World's Streaming ICONs!",
    metaDescription: "iconoglobe - Discover entertainment events, things to do, sites to see within every city and every genre of entertainment",
    metaKeywords: "iconoglobe"
});
			}
		});
		$transitions.onError({}, function(trans){
		//	console.log(trans);
		})
}]);
